import { AccountType } from "../../utils/Enums";
import { ADD_USER, LOGOUT, CHANGE_SELECTED_SMVP } from "../constants/user";

const initialState = {
  user: {},
  accountType: AccountType.Arrangemang,
  samverkansparts: [],
  selectedSamverkanspart: null,
};

export const user = (state = initialState, action) => {
  switch (action.type) {
    case ADD_USER:
      return {
        ...state,
        user: action.payload.user,
        accountType: action.payload.accountType,
        samverkansparts: [...action.payload.samverkansparts],
        selectedSamverkanspart: action.payload.selectedSamverkanspart,
      };
    case CHANGE_SELECTED_SMVP:
      return {
        ...state,
        selectedSamverkanspart: action.payload === null ? null : action.payload.selectedSamverkanspart,
      };
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};
